import CallRecord from './CallRecord';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const CallRecordConfig = {
    auth: authRoles.cc, // admin
    routes: [
        {
            path: '/apps/call-record/',
            component: CallRecord
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/callRecord/CallRecordConfig.js